import { setupApi } from '@/api/config-setup'
import { queryKeys } from '@/constant/common'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import toast from 'react-hot-toast'

async function updateDecoder(interfaceId: number): Promise<void> {
  await setupApi.getDiscoverData(interfaceId)
}

function useDiscoverDataDecoder() {
  const queryClient = useQueryClient()

  return useMutation((payload: any) => updateDecoder(payload.interfaceId), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.controller])
      /**
       * SCRUM-1032 QC, 5 Oct — "Resync should always resync new IO".
       *
       * Output, Input and SDI-12 are three separate whole-list queries, keyed
       * by decoder type and held at `staleTime: Infinity`; the decoder grid
       * only refetches the tab that is mounted. So a resync run from the Output
       * tab left Input and SDI-12 showing the list they had loaded, and the new
       * SDI-12 decoders only appeared after resyncing again from their own tab.
       * One invalidation for the key covers all three.
       */
      queryClient.invalidateQueries([queryKeys.guidedAllDecoders])
      toast.success('Discover Data Success')
    },
    onError: (error: AxiosError<any>) => {
      toast.error(error?.message)
    },
  })
}

export default useDiscoverDataDecoder
